import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Adb2cAuthorisationInterceptor } from './blocks/adb2c/adb2cAuthorisationInterceptor';
import { ConfigurationService } from './core/shell/services/configuration.service';
import { LoggerService } from './blocks/logger/services/logger.service';
import { MomentFormatPipe } from './shared/pipes/moment-format.pipe';
import { provideFormlyCore } from '@ngx-formly/core';
import formConfig from './shared/formly/form-config';
import { SlideCommonService } from './application/common/slide-common.service';
import { ApplicationFormService } from './application/application-form/application-form.service';
import { ApplicationFormDataService } from './application/application-form/application-form-data.service';
import { DataService } from './core/services/data.service';
import { UtilityService } from './shared/services/utility/utility.service';
import { Adb2cService } from './blocks/adb2c/services/adb2c/adb2c.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(
            withInterceptorsFromDi()
        ),
        ConfigurationService,
        LoggerService,
        Adb2cService,
        UtilityService,
        SlideCommonService,
        ApplicationFormService,
        ApplicationFormDataService,
        DataService,
        {
            provide: APP_INITIALIZER,
            useFactory: configProviderFactory,
            deps: [ ConfigurationService, Adb2cService ],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Adb2cAuthorisationInterceptor,
            multi: true,
        },
        MomentFormatPipe,
        provideFormlyCore(formConfig)
    ]
};

export function configProviderFactory(configService: ConfigurationService) {
    return () => configService.requestConfiguration();
}
